import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../../../messages/sign-up-form';
import type { AnalyticsTrackType } from '../../../../../model/wac-signup-form';
import { computeFreeTrialRedirectURL } from '../../../../../service/sign-up-form/free-breach';
import { InfoBox } from './info-box';

export type BreachInfoBoxProps = {
  analyticsTrack: AnalyticsTrackType;
  selectedSiteId: string;
};

export function BreachInfoBox({
  analyticsTrack,
  selectedSiteId
}: BreachInfoBoxProps) {
  const freeTrialRedirectURL = computeFreeTrialRedirectURL(selectedSiteId);
  return (
    <InfoBox>
      <p className="title">
        <FormattedMessage {...messages.freeBreachInfoBoxConsiderTrial} />
      </p>
      <SanitizedFormattedHtmlMessage {...messages.freeBreachInfoBoxCopy} />
      <p
        className="link"
        onClick={() => {
          analyticsTrack.segment('bxpSignupFreeUserBreachStart30DayTrial', {
            selectedSiteId
          });
          window.location.href = freeTrialRedirectURL;
        }}
      >
        <FormattedMessage {...messages.freeBreachInfoBoxStartTrialCta} />
      </p>
    </InfoBox>
  );
}
